






      
import { getDefaultAloIcon } from '@/models/alo/AloIcon'
import Vue from 'vue'  
import Component from 'vue-class-component'  

@Component({
  name: 'IconBtn', 
  props:{            
    iconName:{
      type:String,
      default:''
    },
    selected:{
      type:Boolean,
      default:false
    }                   
  }
})
export default class IconBtn extends Vue {  
  selected!:string    
  iconName!:string

  get label(){
    return this.$t(`Icon.${this.iconName}`)
  }
  
  get icon(){
    return require(`@/assets/icon/${this.iconName}-off.svg`)
  }

  get selectedIcon() {
    return require(`@/assets/icon/${this.iconName}-on.svg`)
  }

  get iconUrl(){
    return this.selected?this.selectedIcon:this.icon
  }

}
